import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface FieldValidationDialogData {
  isSuccess: boolean;
  title: string;
  message: string;
}

@Component({
  selector: 'app-field-validation-dialog',
  templateUrl: './field-validation-dialog.component.html',
  styleUrls: ['./field-validation-dialog.component.scss']
})
export class FieldValidationDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<FieldValidationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FieldValidationDialogData
  ) {}

  onOkClick(): void {
    this.dialogRef.close();
  }
}